import { differenceInCalendarDays } from 'date-fns'
import React from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_NAMES } from '../../Layouts/Authorized/interfaces'
import { routes } from '../../Layouts/Authorized/routes'
import { useKvkEnrollment } from '../../Providers/KvkEnrollmentProvider'
import Styles from './styles.module.scss'

const RENEW_WINDOW_DAYS = 30

/**
 * Persistent top-of-app banner that nudges the parent to renew once the Koran
 * voor Kids access enters its final 30 days. Hidden outside that window and once
 * the study has expired (the Renew gate takes over the whole app then). Never shown
 * when a subscription already renews the access: there is nothing to do.
 */
export const ExpiryBanner = (): JSX.Element | null => {
  const { enrollment } = useKvkEnrollment()

  if (!enrollment?.endDate || !enrollment.active || enrollment.subscribed) return null

  const daysLeft = differenceInCalendarDays(new Date(enrollment.endDate), new Date())
  if (daysLeft < 0 || daysLeft > RENEW_WINDOW_DAYS) return null

  let timeLabel = `over ${daysLeft} dagen`
  if (daysLeft <= 0) timeLabel = 'vandaag'
  else if (daysLeft === 1) timeLabel = 'morgen'

  return (
    <div className={Styles.banner} role="status">
      <span className={Styles.message}>
        <span className={Styles.emoji} aria-hidden="true">
          ⏳
        </span>
        Je toegang tot Koran voor Kids verloopt {timeLabel}.
      </span>

      <Link className={Styles.action} to={routes[ROUTE_NAMES.RENEW_SUBSCRIPTION]}>
        Verleng nu
      </Link>
    </div>
  )
}
